import React from 'react';
import { ItemRenderProps } from '@progress/kendo-react-treeview';

interface CustomItemRenderProps extends ItemRenderProps {
  isExpanded: boolean;
}

export const CustomTreeListItem = (props: CustomItemRenderProps) => {
  const { item } = props;
  const { text } = item;
  const calculateTotalCount = (category, isExpanded) => {
    let count = category.count;
    if (!isExpanded && category.items && category.items.length > 0) {
      category.items.forEach((nestedItem) => {
        count += calculateTotalCount(nestedItem, isExpanded);
      });
    }
    return count;
  };

  const count = calculateTotalCount(item, props.isExpanded);

  return (
    <span>
      <span className="category-name-count-container" title={text}>
        <span className="category-name-ellipsis">{text}</span>
        {count > 0 && (
          <span className="category-count green-chip">{count}</span>
        )}
      </span>
    </span>
  );
};
